import { render, staticRenderFns } from "./addInvoiceQu.vue?vue&type=template&id=477abef6"
import script from "./addInvoiceQu.vue?vue&type=script&lang=js"
export * from "./addInvoiceQu.vue?vue&type=script&lang=js"
import style0 from "./addInvoiceQu.vue?vue&type=style&index=0&id=477abef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports